import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_APP_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_FIREBASE_APP_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);

// Must complete BEFORE any sign-in call, otherwise sessions fall back to
// in-memory persistence and don't survive page reloads. Top-level await
// blocks any module that imports firebaseAuth until this resolves.
//
// If browser storage is unavailable (Safari private mode, locked-down
// enterprise browsers), we fall back to in-memory persistence rather
// than crashing the whole app — the user can still sign in for the
// duration of the session, just not across reloads.
try {
  await setPersistence(firebaseAuth, browserLocalPersistence);
} catch {
  // intentionally swallow — Firebase will use its default in-memory persistence
}
